"use client";

import { Slot } from "@trydig/ui";
import { useStickyHeader } from "@trydig/ui/hooks";
import type { ComponentProps } from "react";

export const StickyState = ({
	asChild,
	...rest
}: ComponentProps<"header"> & {
	asChild?: boolean;
}) => {
	const { getHeaderProps, direction, isTop } = useStickyHeader();
	const Component = asChild ? (Slot as unknown as "header") : "header";

	let headerHeight: string | undefined;
	if (direction === "down") {
		headerHeight = "0px";
	} else if (direction === "up") {
		headerHeight = "var(--header-height)";
	}

	if (isTop) {
		headerHeight = "var(--header-height)";
	}

	return (
		<>
			<Component {...getHeaderProps({})} {...rest} />
			<style>
				{`
				body {
					--dynamic-header-height: ${headerHeight};
				}
			`}
			</style>
		</>
	);
};
